import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const SelfMutualInductanceTransformers = () => (
  <QPhototModuleSubtopic
    title="Self and Mutual Inductance and Transformers"
    videos={[
      "https://www.youtube.com/embed/hoTInTKij0o",
      "https://www.youtube.com/embed/gMn0MDl4vkc",
      "https://www.youtube.com/embed/qQ0yUPrXfCE"
    ]}
    takeaways={[
      { text: "Practice all the problems related to Mutual and Self Inductance." },
      { text: "Expected question in CAT-2 and FAT." }
    ]}
    questions={[
      { image: "/beee_32.jpeg" },
      { image: "/beee_33.jpeg" },
      { image: "/beee_34.jpeg" },
      { image: "/beee_35.jpeg" }
    ]}
    exampleVideos={[]}
  />
);

export default SelfMutualInductanceTransformers;
